export const IconCopy = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M9,9 L5,9 C3.8954305,9 3,9.8954305 3,11 L3,15 C3,16.1045695 3.8954305,17 5,17 L9,17 C10.1045695,17 11,16.1045695 11,15 L11,11 C11,9.8954305 10.1045695,9 9,9 Z M15,11 C16.1045695,11 17,10.1045695 17,9 L17,5 C17,3.8954305 16.1045695,3 15,3 L11,3 C9.8954305,3 9,3.8954305 9,5 L9,7 C11.209139,7 13,8.790861 13,11 L15,11 Z M13,15 C13,17.209139 11.209139,19 9,19 L5,19 C2.790861,19 1,17.209139 1,15 L1,11 C1,8.790861 2.790861,7 5,7 L7,7 L7,5 C7,2.790861 8.790861,1 11,1 L15,1 C17.209139,1 19,2.790861 19,5 L19,9 C19,11.209139 17.209139,13 15,13 L13,13 L13,15 Z"
			/>
		</svg>
	);
};
